import axios from 'axios';
import { getConfig } from '../config/config';
const url = () => {
  return getConfig().urlApi;
};

export const  axiosInstance  = axios.create({
  baseURL: url()
});
